var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6679 7C15.6679 6.58579 16.0037 6.25 16.4179 6.25H22.0001C22.4143 6.25 22.7501 6.58579 22.7501 7V12.5458C22.7501 12.96 22.4143 13.2958 22.0001 13.2958C21.5858 13.2958 21.2501 12.96 21.2501 12.5458V8.80286L15.1142 14.9013C14.6453 15.3674 14.2411 15.7692 13.874 16.0477C13.4805 16.3462 13.0433 16.572 12.5051 16.572C11.9669 16.5719 11.5297 16.346 11.1363 16.0474C10.7693 15.7688 10.3652 15.367 9.89635 14.9007L9.62209 14.628C9.10793 14.1167 8.77458 13.7875 8.49701 13.5769C8.23678 13.3794 8.11512 13.3573 8.03455 13.3574C7.95399 13.3574 7.83234 13.3795 7.57225 13.5772C7.29484 13.7881 6.96173 14.1175 6.44795 14.6292L2.52928 18.5314C2.23577 18.8237 1.7609 18.8227 1.46862 18.5292C1.17634 18.2357 1.17734 17.7608 1.47084 17.4686L5.42439 13.5315C5.89332 13.0645 6.29748 12.662 6.66458 12.383C7.05808 12.0839 7.49542 11.8576 8.03401 11.8574C8.5726 11.8572 9.0101 12.0832 9.40381 12.382C9.77112 12.6607 10.1756 13.063 10.6448 13.5296L10.9191 13.8024C11.4328 14.3132 11.7658 14.6421 12.0432 14.8526C12.3031 15.0499 12.4247 15.072 12.5052 15.072C12.5858 15.072 12.7074 15.0499 12.9674 14.8527C13.2448 14.6423 13.5779 14.3134 14.0917 13.8027L20.1815 7.75H16.4179C16.0037 7.75 15.6679 7.41421 15.6679 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseUp);
export default __webpack_public_path__ + "static/media/CourseUp.bed2ec94e965e2cdfd40f21dc185662d.svg";
export { ForwardRef as ReactComponent };